/* ==========================================================================
   Tiaroo 动效层
   --------------------------------------------------------------------------
   设计原则：整个脚本包在 try/catch 里，任何一步失败都只是"没有动效"，
   绝不会把页面搞坏，也绝不会让内容留在隐藏状态。
   ========================================================================== */
(function () {
  'use strict';

  var CFG = (window.TiarooMotion || {});
  if (CFG.enabled === false) return;

  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}
  if (reduce) return;

  var doc = document;
  var root = doc.documentElement;

  function qsa(sel, ctx) {
    try { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
    catch (e) { return []; }
  }
  function on(el, ev, fn, opts) {
    try { el.addEventListener(ev, fn, opts); } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * 1. 滚动进场
   * ------------------------------------------------------------------ */

  function isChrome(section) {
    // 页头 / 公告栏 / 页脚不参与滚动进场，它们一进来就该在原位
    if (!section) return true;
    var cls = section.className || '';
    var id = section.id || '';
    if (/group-header|group-footer/.test(cls)) return true;
    if (/__(header|announcement|footer|menu)/.test(id)) return true;
    if (section.querySelector('header, footer, .announcement-bar, .header-wrapper')) return true;
    return false;
  }

  function markStagger(section) {
    // 让分区里的主要块错开出现。只取"直接的展示层子元素"，别钻太深，
    // 否则每个字都会单独动，看起来很碎。
    var pools = qsa(
      '.tiaro-hero__content, .texture-lib__grid, .trust-bar__grid, ' +
      '.firmness__list, .faq-sec__list, .collection__grid, .grid, ' +
      '.texture-lib__item, .card-wrapper, .faq-sec__item, .firmness__row',
      section
    );
    var picked = [];
    pools.forEach(function (p) {
      if (picked.indexOf(p) !== -1) return;
      // 已经被别的 pool 包住的就跳过，避免父子都动
      for (var i = 0; i < picked.length; i++) {
        if (picked[i].contains(p)) return;
      }
      picked.push(p);
    });
    picked.forEach(function (el, i) {
      if (el.classList.contains('tiaro-stagger')) return;
      el.style.setProperty('--tiaro-i', String(Math.min(i, 8)));
      el.classList.add('tiaro-stagger');
    });
  }

  function setupReveal() {
    var sections = qsa('.shopify-section').filter(function (s) {
      return !isChrome(s);
    });
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      // 浏览器太老：什么都不做，页面保持原样可见
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('tiaro-in');
        io.unobserve(el);
        // 动画结束后撤掉 will-change，别长期占合成层
        setTimeout(function () {
          el.classList.add('tiaro-done');
        }, 1100);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    sections.forEach(function (s) {
      // 首屏（页面最上面那块）用加载动画，不要等滚动
      var r = s.getBoundingClientRect();
      var aboveFold = r.top < window.innerHeight * 0.9;

      markStagger(s);
      s.classList.add('tiaro-anim');

      if (aboveFold) {
        // 已经看得见了：下一帧就播，给个很短的启动延迟让过渡生效
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            s.classList.add('tiaro-in');
            setTimeout(function () { s.classList.add('tiaro-done'); }, 1100);
          });
        });
      } else {
        io.observe(s);
      }
    });

    // 兜底：3 秒后如果还有没进场的（比如 IO 被什么挡住），强制显示
    setTimeout(function () {
      qsa('.tiaro-anim:not(.tiaro-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('tiaro-in');
      });
    }, 3000);

    // 极端兜底：万一中间抛错，8 秒后全部显示，绝不留下空白
    setTimeout(function () {
      qsa('.tiaro-anim:not(.tiaro-in)').forEach(function (el) {
        el.classList.add('tiaro-in');
      });
    }, 8000);
  }

  /* ------------------------------------------------------------------ *
   * 2. 首屏视差
   * ------------------------------------------------------------------ */

  function setupParallax() {
    if (window.matchMedia('(hover: none)').matches) {
      root.classList.add('tiaro-parallax-off');
      return;
    }
    var hero = doc.querySelector('.tiaro-hero');
    if (!hero) return;

    var ticking = false, tx = 0, ty = 0;

    function apply() {
      ticking = false;
      hero.style.setProperty('--tiaro-px', tx.toFixed(3));
      hero.style.setProperty('--tiaro-py', ty.toFixed(3));
    }

    on(document, 'mousemove', function (e) {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        tx = (e.clientX / window.innerWidth - 0.5) * -1;
        ty = (e.clientY / window.innerHeight - 0.5) * -1;
        apply();
      });
    }, { passive: true });

    // 鼠标移出窗口时归位
    on(document, 'mouseleave', function () {
      tx = 0; ty = 0; apply();
    });
  }

  /* ------------------------------------------------------------------ *
   * 3. 公告条跑马灯
   * ------------------------------------------------------------------ */

  function setupMarquee() {
    if (CFG.marquee === false) return;
    var bars = qsa('.announcement-bar__message');
    // 多条公告时 Dawn 会做成轮播，动它的 DOM 会把轮播弄坏 —— 直接跳过
    if (bars.length !== 1) return;

    var msg = bars[0];
    var host = msg.parentElement;
    if (!host || host.classList.contains('tiaro-marquee')) return;

    var text = (msg.textContent || '').trim();
    if (!text) return;

    try {
      var track = doc.createElement('div');
      track.className = 'tiaro-marquee__track';
      // 复制份数按屏幕宽度算，保证滚一圈时看不出接缝
      var copies = Math.max(2, Math.ceil((window.innerWidth * 2) / Math.max(text.length * 9, 200)));
      copies = Math.min(copies, 8);
      for (var i = 0; i < copies; i++) {
        var sp = doc.createElement('span');
        sp.textContent = text;
        track.appendChild(sp);
      }
      msg.textContent = '';
      msg.appendChild(track);
      host.classList.add('tiaro-marquee');
      // 跑一圈的时长跟文字量走，长短句速度看起来才一致
      host.style.setProperty('--tiaro-mo-marquee', (copies * 13) + 's');
    } catch (e) {
      // 失败就保持 Dawn 原样
    }
  }

  /* ------------------------------------------------------------------ *
   * 4. 顶部滚动进度条 + 悬停类
   * ------------------------------------------------------------------ */

  function setupProgress() {
    if (CFG.progress === false) return;
    var wrap = doc.createElement('div');
    wrap.className = 'tiaro-progress';
    wrap.setAttribute('aria-hidden', 'true');
    var bar = doc.createElement('div');
    bar.className = 'tiaro-progress__bar';
    wrap.appendChild(bar);
    doc.body.appendChild(wrap);

    var ticking = false;
    function update() {
      ticking = false;
      var h = doc.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    on(window, 'resize', update, { passive: true });
    update();
  }

  function markHover() {
    // 商品卡
    qsa('.card-wrapper .card__media, .card-wrapper .media').forEach(function (el) {
      el.classList.add('tiaro-zoom');
    });
    qsa('.card-wrapper').forEach(function (el) {
      el.classList.add('tiaro-lift');
    });
    // 自定义分区的卡片
    qsa('.texture-lib__card, .firmness__card, .trust-bar__item').forEach(function (el) {
      el.classList.add('tiaro-lift');
    });
    // 首屏 logo / 主视觉呼吸
    qsa('.tiaro-hero__content > *').forEach(function (el, i) {
      if (i === 0) el.classList.add('tiaro-breathing');
    });
  }

  /* ------------------------------------------------------------------ *
   * 启动
   * ------------------------------------------------------------------ */

  function boot() {
    try { markHover(); } catch (e) {}
    try { setupReveal(); } catch (e) {}
    try { setupParallax(); } catch (e) {}
    try { setupMarquee(); } catch (e) {}
    try { setupProgress(); } catch (e) {}
  }

  if (doc.readyState === 'loading') {
    on(doc, 'DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 主题编辑器里切换设置或切分区后要重跑，不然预览不同步
  on(doc, 'shopify:section:load', function () {
    try { markHover(); } catch (e) {}
  });
})();
